var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67626 3.67166C1.44125 3.89975 1.44125 4.26749 1.67626 4.49558L5.66187 8.36384C5.84892 8.54539 6.15108 8.54539 6.33813 8.36384L10.3237 4.49558C10.5588 4.26749 10.5588 3.89975 10.3237 3.67166C10.0887 3.44356 9.70983 3.44356 9.47482 3.67166L5.9976 7.04184L2.52038 3.667C2.29017 3.44356 1.90648 3.44356 1.67626 3.67166Z",
    fill: "#6265A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.fd7e86f6.svg";
export { ForwardRef as ReactComponent };